import React from 'react';
import _get from 'lodash/get';
import ShowIf from '@Atoms/ShowIf';
import { useLearnosityExamAccess } from '@components/Component/LearnosityExams/ShowIfLearnosityExamFlagEnabled';
import { useFeatureFlagEnabled } from '@components/Atoms/FeatureFlagGuard/hooks';
import { FEATURE_SHOW_CALENDAR } from '@components/Atoms/FeatureFlagGuard/constants';
import { NavBarGroup, NavBarPrimary, NavBarItem, InfoUserGroup } from './TopNavBar.style';
import NavBarItemComponent from './NavBarItemComponent';
import TeacherCourseSetup from '../TeacherCourseSetup';
import { useInteractionContext } from '@components/ElementAnalytics/InteractionContext';

const TeacherNavBar = ({
  state,
  props,
  navBarItemProps,
  renderUserIcon,
  closeCreateCourseForm,
  openCreateCourseForm,
}) => {
  const { getTestId } = useInteractionContext();
  const { isDropdown, isCreateCourseOpen, coauthorEnabled } = state;
  const { user, curriculumDetail } = props;
  const email = _get(user, 'email', '');
  const isReportViewer = _get(user, 'is_report_viewer', false);
  const isThirdParty =
    _get(user, 'rostering_method', '') !== 'unspecified' &&
    _get(user, 'rostering_method', '') !== 'manual' &&
    _get(user, 'sso_provider_slug', '') !== 'manual' &&
    _get(user, 'sso_provider_slug', '') !== 'unspecified';
  const isLearnosityExamEnabled = useLearnosityExamAccess();
  const showCalendar = useFeatureFlagEnabled({ featureName: FEATURE_SHOW_CALENDAR });
  return (
    <NavBarGroup>
      <NavBarPrimary>
        <NavBarItemComponent
          {...navBarItemProps}
          url="/dashboard/course/"
          icon="chalktalk-icon-home"
          dataTip=""
          label="Dashboard"
        />
        <NavBarItemComponent
          {...navBarItemProps}
          url="/lessons/course/"
          icon="chalktalk-icon-tech"
          dataTip=""
          label="Lessons"
        />
        <ShowIf If={curriculumDetail.has_exam && !isLearnosityExamEnabled} key="test">
          <NavBarItemComponent
            {...navBarItemProps}
            url="/test/course/"
            icon="chalktalk-icon-note-list"
            dataTip=""
            label="Tests"
          />
        </ShowIf>
        <ShowIf If={curriculumDetail.has_exam && isLearnosityExamEnabled} key="tests">
          <NavBarItemComponent
            {...navBarItemProps}
            url="/tests/course/"
            icon="chalktalk-icon-note-list"
            dataTip=""
            label="Tests"
            actionRequiredKey={["LE"]}
          />
        </ShowIf>
        <ShowIf If={showCalendar === true}>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/schedule/course/"
            icon="chalktalk-calendar"
            dataTip=""
            label="Calendar"
          />
        </ShowIf>
        {coauthorEnabled && (
          <NavBarItemComponent
            {...navBarItemProps}
            url="/coauthor/course/"
            icon="chalktalk-icon-teacher"
            dataTip=""
            label="Co-Author"
          />
        )}
        {isReportViewer && (
          <NavBarItemComponent
            {...navBarItemProps}
            url="/admin/reports/generator"
            icon="chalktalk-icon-reports"
            dataTip=""
            label="Reports"
            transform
            hasSection={false}
            isExternal={false}
            isAdmin
          />
        )}
      </NavBarPrimary>
      <InfoUserGroup>
        <NavBarPrimary>
          <NavBarItemComponent
            {...navBarItemProps}
            url="/teacher/course/"
            icon="chalktalk-icon-teacher"
            dataTip="Teacher Training"
            label=""
            transform
            hasSection={false}
          />
          <NavBarItemComponent
            {...navBarItemProps}
            url="teacher-help-link"
            icon="chalktalk-icon-questionmark"
            dataTip="Help Articles"
            label=""
            transform={false}
            hasSection={false}
            isExternal
          />
          {!isThirdParty && (
            <NavBarItemComponent
              {...navBarItemProps}
              url="/management/course/"
              icon="chalktalk-course-management"
              dataTip="Course Management"
              label=""
              transform
              hasSection={false}
            />
          )}
          <NavBarItem tabIndex={0} data-testid={getTestId("join-or-create")}
            onClick={openCreateCourseForm}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openCreateCourseForm();
              }
            }}>
            <span
              className="chalktalk-course-plus"
              data-tip="Join Section or Create Course"
              data-for="tooltip-top-nav-bar"
            />
          </NavBarItem>
          {renderUserIcon(user, isDropdown)}
          {isCreateCourseOpen && <TeacherCourseSetup onClose={closeCreateCourseForm} />}
        </NavBarPrimary>
      </InfoUserGroup>
    </NavBarGroup>
  );
};

export default TeacherNavBar;
